// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1dLZ0","inputWrap":"CustomTip_inputWrap__U88ct"};